<template>
  <div>
    <section class="section auth-ui-section--has-margin-top auth-ui-section--is-narrow">
      <div class="container auth-ui-container--has-centered-content">
        <v-card :classes="'auth-ui-card--is-not-full-width'">
          <div slot="header-title">
            {{ $t('auth.externalSignInTitle') }}
          </div>
          <form slot="body">
            <div class="auth-ui-multi-sign-in-container">
              <div
                class="auth-ui-multi-sign-in-col"
                style="margin:0 auto;"
              >
                <div class="field">
                  <div class="control auth-ui-button-and-spinner-container">
                    <button
                      class="button button-is-centered is-link auth-ui-button"
                      @click.prevent="signIn('auth0')"
                    >
                      {{ $t('auth.signInButton') }} {{ $t('auth.externalSignInButton1') }}
                    </button>
                  </div>
                </div>

                <div>
                  <div>
                    <div class="auth-ui-form-reg-desc mt-24">
                      {{ $t('auth.signInRegisterLinkDescription') }}
                      <a
                        :href="getRegisterLink('auth0')"
                        class="auth-ui-form__link"
                      >
                        {{ $t('auth.signInRegisterLink') }}
                      </a>
                    </div>
                    <div class="mt-8">
                      <a
                        :href="getPasswordResetLink('auth0')"
                        class="auth-ui-form__link"
                      >
                        {{ $t('auth.forgotPasswordLink') }}
                      </a>
                    </div>
                    <div class="fs-12 mt-10">
                      <a
                        href="https://www.k-kyla.fi/ukk"
                        class="auth-ui-form__link-secondary"
                      >{{ $t('auth.helpWithSignin') }}</a>
                    </div>
                    <aside class="fs-12 mt-10 auth-ui-form-reg-desc">
                      {{
                        $t('auth.emailDescription')
                      }}
                    </aside>
                  </div>
                </div>
              </div>
            </div>

            <div class="auth-ui-card-separator" />

            <div class="auth-ui-multi-sign-in-container">
              <div class="auth-ui-multi-sign-in-col auth-ui-multi-sign-is-smaller">
                <div class="mb-8 is-bolded">
                  {{ $t('auth.externalSignInTitle2') }}
                </div>
                <div
                  class="field"
                  style="margin-bottom:24px;"
                >
                  <div
                    class="control auth-ui-button-and-spinner-container is-centered fw-900 fs-12"
                  >
                    <router-link
                      :to="getSignInLink('cognito')"
                      class="auth-ui-form__link"
                    >
                      {{ $t('auth.signInButton') }} {{ $t('auth.externalSignInButton3') }}
                    </router-link>
                  </div>
                </div>
                <div>
                  <div class="fs-12">
                    <div>
                      <div class="auth-ui-form-reg-desc">
                        {{ $t('auth.signInRegisterLinkDescription') }}
                        <router-link
                          :to="getRegisterLink('cognito')"
                          class="auth-ui-form__link-secondary"
                        >
                          {{ $t('auth.signInRegisterLink') }}
                        </router-link>
                      </div>
                      <div>
                        <router-link
                          :to="getPasswordResetLink('cognito')"
                          class="auth-ui-form__link-secondary"
                        >
                          {{ $t('auth.forgotPasswordLink') }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="auth-ui-multi-sign-in-col auth-ui-multi-sign-is-smaller">
                <div class="mb-8 is-bolded fs-14">
                  {{ $t('auth.externalSignInTitle3') }}
                </div>
                <div
                  class="field"
                  style="margin-bottom:24px;"
                >
                  <div
                    class="control auth-ui-button-and-spinner-container is-centered fw-900 fs-12"
                  >
                    <router-link
                      :to="getSignInLink('ku_tunnus')"
                      class="auth-ui-form__link"
                    >
                      {{ $t('auth.signInButton') }} {{ $t('auth.externalSignInButton2') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="auth-ui-card-separator" />
            <div class="auth-ui-multi-sign-in-container mh-80">
              <div class="auth-ui-multi-sign-in-col">
                <div class="fs-12">
                  <a
                    href="https://www.k-kyla.fi/tietosuojaseloste"
                    class="auth-ui-form__link is-underlined"
                  >{{ $t('auth.privacyPolicyLink') }}</a>
                </div>
              </div>

              <div class="auth-ui-multi-sign-in-col">
                <div class="fs-12">
                  <a
                    href="https://www.k-kyla.fi/kayttajasopimus"
                    class="auth-ui-form__link is-underlined"
                  >{{ $t('auth.userAgreementLink') }}</a>
                </div>
              </div>
            </div>
          </form>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
/* ============
       * Choose Sign In Page
       * ============
       *
       * Page where the user choose which way to sign in.
       */

import VCard from '../../components/Card.vue';

export default {
  name: 'AuthMultipleSignIn',

  components: {
    VCard,
  },

  data() {
    return {
      errors: {
        email: false,
        password: false,
      },
      serverResponse: {
        message: '',
        visible: false,
      },
      signInIsDisabled: false,
      title: process.env.VUE_APP_PAGE_TITLE,
      backendURL: process.env.VUE_APP_BACKEND_URL,
    };
  },

  methods: {
    signIn(method) {
      const target = this.$store.state.route.query.target;
      if (method === 'auth0') {
        window.location = target
          ? `${this.backendURL}/auth0_login?target=${target}`
          : `${this.backendURL}/auth0_login`;
      }
      if (method === 'cognito') {
        this.$router.push({ name: 'auth.sign.in', query: this.$store.state.route.query });
      }
      // should implement ku_tunnus once it's ready
    },

    getSignInLink(method) {
      const target = this.$store.state.route.query.target;
      if (method === 'auth0') {
        return target
          ? `${this.backendURL}/auth0_login?target=${target}`
          : `${this.backendURL}/auth0_login`;
      }
      if (method === 'cognito') {
        return {
          name: 'auth.sign.in',
          query: this.$store.state.route.query,
        };
      }
      // should implement ku_tunnus once it's ready
      if (method === 'ku_tunnus') {
        return '#ku-tunnus';
      }
      return '#';
    },

    getRegisterLink(method) {
      const queryParams = (new URL(document.location)).searchParams;
      const target = queryParams.get('target');
      if (method === 'auth0') {
        return target
          ? `${this.backendURL}/auth0_register?target=${target}`
          : `${this.backendURL}/auth0_register`;
      }
      if (method === 'cognito') {
        return {
          name: 'auth.register',
          query: this.$store.state.route.query,
        };
      }
      return '#';
    },

    getPasswordResetLink(method) {
      const queryParams = (new URL(document.location)).searchParams;
      const target = queryParams.get('target');
      if (method === 'auth0') {
        return target
          ? `${this.backendURL}/auth0_reset_password?target=${target}`
          : `${this.backendURL}/auth0_reset_password`;
      }
      if (method === 'cognito') {
        return {
          name: 'auth.request.reset.password',
          query: this.$store.state.route.query,
        };
      }
      return '#';
    },

    // some ugly hardcoded kesko related stuff
    // if there is other customer in future that needs multiple sign in
    // following (and even more) needs to be done more dynamically
    // goToHelp() {
    //   window.location = 'https://www.k-kyla.fi/ukk';
    // },

    // goToPrivacyPolicy() {
    //   window.location = 'https://www.k-kyla.fi/tietosuojaseloste';
    // },

    // goToUserAgreemnet() {
    //   window.location = 'https://www.k-kyla.fi/kayttajasopimus';
    // },
  },
};
</script>
